// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"FJ-z","smallCardRow":"GJ-z","largeCardRow":"HJ-z","productSearchRow":"IJ-z","curatedRow":"JJ-z"};